export {
    LIBRARY_MODE_ALL,
    LIBRARY_MODE_ARCHIVED,
    LIBRARY_MODE_OWNED,
    LIBRARY_MODE_SHARED
}

const LIBRARY_MODE_ALL = "all" as const
const LIBRARY_MODE_ARCHIVED = 'archived' as const
const LIBRARY_MODE_OWNED = 'owned' as const
const LIBRARY_MODE_SHARED = 'shared' as const